<span class="{{candidatureSvc.getStateColorClass(getStatusChoice())}}" [style.padding]="forcePadding">
    <span [innerHTML]="getIconIfToTreat()"></span>{{getStatusLabel()}}
</span>
